import { useCallback, useRef } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

/**
 * Fires once per mount, on the first scroll gesture, to signal that a signer discovered
 * the carousel scrolls rather than measuring continuous scroll position.
 */
export function useCarouselScrollTracking() {
	const track = useTracking();
	const hasTrackedRef = useRef(false);

	return useCallback(() => {
		if (hasTrackedRef.current) return;
		hasTrackedRef.current = true;
		void track('psf_share_channel_carousel_scroll');
	}, [track]);
}
